import { createPortal } from "react-dom"
import { type PropsWithChildren, useEffect, useState } from "react"

type PortalProps = PropsWithChildren<{ targetNode: HTMLElement | null }>

export function Portal({ children, targetNode }: PortalProps) {
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)

        return () => setMounted(false)
    }, [])

    return mounted && targetNode ? createPortal(children, targetNode) : null
}
